import { useEffect, useState } from 'react';

const useOnDrag = (ref: React.RefObject<HTMLElement>): boolean => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleTouchStart = () => {
      setIsDragging(true);
    };

    const handleTouchEnd = () => {
      setIsDragging(false);
    };

    element.addEventListener('touchstart', handleTouchStart);
    element.addEventListener('touchend', handleTouchEnd);

    return () => {
      element.removeEventListener('touchstart', handleTouchStart);
      element.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  return isDragging;
};

export default useOnDrag;
